import { ArrowRightIcon } from '@root/styles/icons';
import styled from 'styled-components';

const StyledArrow = styled(ArrowRightIcon)`
  color: ${({ theme }) => theme.defaultColors.grey};
  margin: 0 20px;
`;

export const MobileStyledArrow = styled(StyledArrow)`
  margin: 24px 10px 0 10px;
`;

export const StyledMobileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;

  .SingleDatePickerInput {
    padding-left: 10px;
  }

  .SingleDatePicker_picker {
    display: flex;
    justify-content: center;
    top: 20px !important;
    width: 100%;
    background-color: #ffffff;
  }

  .DayPicker__withBorder {
    box-shadow: none;
  }

  .DayPicker {
    position: relative;
    display: flex;
    top: -73px;
    min-width: 100vw;
    height: 100%;
    min-height: 330px;
    justify-content: center;
    padding-top: 0px !important;

    * {
      border-color: transparent !important;
    }

    .DayPicker_weekHeader {
      top: 55px;
    }

    .CalendarMonth_caption {
      top: 0;
      padding-bottom: 20px;
    }

    .DayPicker_focusRegion {
      width: 100%;
    }

    .DayPicker_transitionContainer {
      height: 310px !important;
    }
  }
`;

export const StyledMobileTextLabel = styled.label`
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  margin-bottom: 8px;
  font-size: 15px;
`;

export const StyledMobileLabel = styled.label`
  display: flex;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.defaultColors.grey};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  position: relative;
  min-height: 56px;
  padding-left: 10px;
  align-items: center;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: calc(50% - 4px);
    right: 14px;
    border-top: 3px solid transparent;
    border-right: 3px solid ${({ theme }) => theme.defaultColors.fontPrimary};
    border-bottom: 2px solid ${({ theme }) => theme.defaultColors.fontPrimary};
    border-left: 2px solid transparent;
    transform: rotate(45deg);
  }
`;

export const StyledMobileInput = styled.input`
  width: 0;
  height: 0;
  position: absolute;
  left: -100vw;
  top: -100vh;
  font-size: 16px;

  &:focus + ${StyledMobileLabel} {
    border-color: ${({ theme }) => theme.customColors.primary};
  }
`;
